import { render, staticRenderFns } from "./CompanyProfileNeeds.vue?vue&type=template&id=cf42e894"
import script from "./CompanyProfileNeeds.vue?vue&type=script&lang=js"
export * from "./CompanyProfileNeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports